export const REGIONS = {
  india: {
    code: "India",
    name: "India",
    titleA: "Digital Gift Cards,",
    titleB: "Made for India",
    sub: "From Myntra to MakeMyTrip, Zomato to Taj Hotels — Vowpin Global distributes India's most loved brands as instant digital gift cards for corporate rewards, loyalty programs, and customer campaigns.",
    cta: "Launching a rewards program in India?",
    ctaSub: "Tell us your audience and volume — we'll curate the right Indian brands and send your best-offer pricing.",
  },
  uae: {
    code: "UAE",
    name: "the UAE",
    titleA: "Digital Gift Cards,",
    titleB: "Made for the UAE",
    sub: "From Noon to Careem, Talabat to Virgin — Vowpin Global distributes the UAE's favourite brands as instant digital gift cards for corporate rewards, loyalty programs, and customer campaigns.",
    cta: "Launching a rewards program in the UAE?",
    ctaSub: "Tell us your audience and volume — we'll curate the right UAE brands and send your best-offer pricing.",
  },
  ksa: {
    code: "KSA",
    name: "Saudi Arabia",
    titleA: "Digital Gift Cards,",
    titleB: "Made for Saudi Arabia",
    sub: "From Amazon to Noon, Mobily to Zain — Vowpin Global distributes Saudi Arabia's favourite brands as instant digital gift cards for corporate rewards, loyalty programs, and customer campaigns.",
    cta: "Launching a rewards program in Saudi Arabia?",
    ctaSub: "Tell us your audience and volume — we'll curate the right Saudi brands and send your best-offer pricing.",
  },
  usa: {
    code: "USA",
    name: "the USA",
    titleA: "Digital Gift Cards,",
    titleB: "Made for the USA",
    sub: "From Amazon to Walmart, Apple to GameStop — Vowpin Global distributes America's most loved brands as instant digital gift cards for corporate rewards, loyalty programs, and customer campaigns.",
    cta: "Launching a rewards program in the USA?",
    ctaSub: "Tell us your audience and volume — we'll curate the right American brands and send your best-offer pricing.",
  },
};

export const REGION_LINKS = Object.entries(REGIONS).map(([slug, r]) => ({
  slug,
  label: `${r.name === "the UAE" ? "UAE" : r.name === "the USA" ? "USA" : r.name} Catalogue`,
  to: `/regions/${slug}`,
}));
